import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import React, { use, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AadhaarSchema } from "../formikSchema";
import { useDispatch } from "react-redux";
import { userRegistrationThunk, aadharRegisterThunk } from "../redux/thunk/registerThunk";
import { AppDispatch } from "@store/store";
import { resetUserRegistration } from "../redux/registerSlice";
import { toast } from "react-toastify";


const AadhaarRegistrationModal = () => {
  const [isEnabled, setIsEnabled] = useState(false);
  const [aadhaar, setAadhaar] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const handleToggle = () => {
    setIsEnabled((prev) => !prev);
  };

  useEffect(() => {
    dispatch(resetUserRegistration());
  }, []);

  return (
    <div>
      <Box className="box-modal">
        <Box
          display="flex"
          justifyContent="center"
          sx={{ mt: { xs: 4, md: 0 } }}
        > 
            <Paper elevation={3} className="login-box pb-4 mb-4">
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: "24px",
                  pb: 3,
                }}
              >
                New Registration
              </Typography>
              <>
                <Box className="btn-wrapper">
                  <Button
                    fullWidth
                    variant="contained"
                    className="btnContinue"
                    onClick={async (e) => {
                      e.preventDefault();
                      const res = await dispatch(aadharRegisterThunk()).unwrap();
                      if (res.redirectURL) {
                        window.location.href = res.redirectURL;
                      }
                    }}
                  >
                    Register
                  </Button>
                </Box>

                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: "14px",
                    color: "#61646b",
                    margin: "10px 5px 30px",
                  }}
                >
                  You will redirect to the Meri Pehchaan website for Aadhaar Registration
                </Typography>
              </>

              <Box
                sx={{
                  backgroundColor: "#F2F2F2",
                  py: 2,
                  px: 3,
                  textAlign: "center",
                  width: "calc(100% + 70px)",
                  margin: "0 0 0 -40px",
                  borderBottomLeftRadius: "15px",
                  borderBottomRightRadius: "15px",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 500, fontSize: "14px" }}
                >
                  Already registered?{" "}
                  <span
                    style={{
                      color: "#3a1c73",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() => navigate("/")}
                  >
                    Login
                  </span>{" "}
                  to continue.
                </Typography>
              </Box>
            </Paper> 
        </Box>
      </Box>
    </div>
  );
};

export default AadhaarRegistrationModal;
